<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title" id="createAppointmentLabel">Receipt Preview</h5>
        <button type="button" @click="closepModal">X</button>
      </div>
      <div class="modal-body">
        <div class="receipt thermal-receipt">
          <!-- Company Header -->
          <div class="text-center">
            <!-- Logo container - properly aligned -->
            <div class="logo-container">
              <img :src="logoToShow" class="branding-logo" alt="logo" />
            </div>
            <h2 class="company-name">{{ company.company_name }}</h2>
            <p class="company-info">{{ company.address }}</p>
            <p class="company-info">
              {{ company.company_location }}, {{ company.country }}
            </p>
            <p class="company-info">{{ company.company_phone }}</p>
            <div class="separator">---------------------------</div>
          </div>

          <!-- Transaction Info -->
          <table
            class="transaction-info"
            width="100%"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td width="35%"><strong>Date:</strong></td>
              <td width="65%" class="text-right">
                <strong>{{ tf(date) }}</strong>
              </td>
            </tr>
            <tr>
              <td><strong>Receipt #:</strong></td>
              <td class="text-right">
                <strong>{{ receipt_no }}</strong>
              </td>
            </tr>
            <tr>
              <td><strong>Patient:</strong></td>
              <td class="text-right patient-name">
                <strong>{{
                  payments?.items?.[0]?.customer_name || "__________"
                }}</strong>
              </td>
            </tr>
          </table>

          <div class="separator">---------------------------</div>

          <!-- Items Table -->
          <table
            class="items-table"
            width="100%"
            cellspacing="0"
            cellpadding="0"
          >
            <!-- Table Header -->
            <thead>
              <tr class="table-header">
                <th width="45%" class="text-left"><strong>ITEM</strong></th>
                <th width="20%" class="text-center"><strong>QTY</strong></th>
                <th width="35%" class="text-right"><strong>AMOUNT</strong></th>
              </tr>
            </thead>

            <tr>
              <td colspan="3">
                <div class="separator">--------------------------</div>
              </td>
            </tr>

            <!-- Items -->
            <tbody>
              <tr
                v-for="payment in payments.items"
                :key="payment.payment_id"
                class="item-row"
              >
                <td class="item-name text-left">
                  <strong>{{ payment.charge_name }}</strong>
                </td>
                <td class="item-qty text-center">
                  <strong>{{ payment.quantity }}</strong>
                </td>
                <td class="item-price text-right">
                  <strong>{{ formatCurrency(payment.amount) }}</strong>
                </td>
              </tr>
            </tbody>

            <!-- Total Separator -->
            <tr>
              <td colspan="3">
                <div class="separator">===========================</div>
              </td>
            </tr>

            <!-- Total Row -->
            <tfoot>
              <tr class="total-section">
                <td colspan="2" class="text-left"><strong>TOTAL</strong></td>
                <td class="total-amount text-right">
                  <strong>{{ formatCurrency(payments.total_amount) }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>

          <div class="separator">===========================</div>

          <!-- Footer -->
          <div class="receipt-footer">
            <p class="cashier-info">
              <strong>Cashier: {{ cashier }}</strong>
            </p>
            <div class="separator">---------------------------</div>
            <p class="thank-you"><strong>Thank you for your visit!</strong></p>
            <p class="receipt-id">
              <strong>Receipt ID: {{ receipt_no }}</strong>
            </p>
          </div>
        </div>

        <div style="text-align: center; margin-top: 20px">
          <button @click="printReceipt" class="print-btn">Print Receipt</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import formatDateTime from "../../../timezone/utc_local_time";

export default {
  name: "receiptModal",
  data() {
    return {
      company: {},
      payments: {},
      cashier: "",
      date: "",
      receipt_no: "",
    };
  },
  props: {
    receiptID: {
      type: [String, Number],
    },
  },
  computed: {
    logoToShow() {
      return this.$store.getters.currentLogo || this.logo;
    },
  },
  methods: {
    tf(param) {
      return formatDateTime(param);
    },

    formatCurrency(amount) {
      if (!amount) return "0.00";
      return parseFloat(amount).toFixed(2);
    },

    closepModal() {
      this.$emit("close-receipt-modal");
    },

    async get_payments() {
      const url = "get_receipt_payments/" + this.receiptID;
      const response = await generalApiRequest(url, "GET", {}, 1);
      this.payments = response.data;

      this.cashier =
        response.data.items.length > 0
          ? response.data.items[0].cashier_name
          : "";
      this.date =
        response.data.items.length > 0
          ? response.data.items[0].payment_date
          : "";
      this.receipt_no =
        response.data.items.length > 0 ? response.data.items[0].receipt_id : "";
    },

    async get_company() {
      const url = "get_company_details";
      const response = await generalApiRequest(url, "GET", {}, 1);
      this.company = response.data;
    },

    printReceipt() {
      const printContents = this.$el
        .querySelector(".thermal-receipt")
        .cloneNode(true);

      // Remove any interactive elements
      const buttons = printContents.querySelectorAll("button");
      buttons.forEach((btn) => btn.remove());

      const printWindow = window.open("", "_blank", "height=600,width=400");
      printWindow.document.write("<!DOCTYPE html><html><head>");
      printWindow.document.write("<title>Print Receipt</title>");
      printWindow.document.write("<style>");
      printWindow.document.write(`
        @page {
          size: 60mm auto;
          margin: 0;
          padding: 0;
        }
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Courier New', monospace !important;
          max-width: 100%;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        html, body {
          width: 60mm !important;
          max-width: 60mm !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        body {
          font-family: 'Courier New', monospace !important;
          font-size: 10px !important;
          line-height: 1.1 !important;
          width: 60mm !important;
          max-width: 60mm !important;
          padding: 0 !important;
          margin: 0 auto !important;
          color: #000000 !important;
          background: white;
          -webkit-print-color-adjust: exact;
          font-weight: bold !important;
        }
        
        .thermal-receipt {
          width: 60mm !important;
          max-width: 60mm !important;
          margin: 0 auto !important;
          padding: 1mm 2mm !important;
          overflow: hidden;
          word-wrap: break-word;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        /* Professional Logo Alignment */
        .logo-container {
          text-align: center;
          width: 100%;
          margin: 0 auto 3mm auto;
          padding: 2mm 0;
        }
        
        .branding-logo {
          display: block;
          margin: 0 auto;
          max-width: 35mm !important;
          max-height: 15mm !important;
          width: auto;
          height: auto;
          object-fit: contain;
          image-rendering: -webkit-optimize-contrast;
          image-rendering: crisp-edges;
        }
        
        .text-center {
          text-align: center;
          width: 100%;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .text-left {
          text-align: left;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .text-right {
          text-align: right;
          color: #000000 !important;
          font-weight: bold !important;
        }
      
        .company-name {
          font-size: 11px !important;
          font-weight: bold !important;
          margin: 2px 0;
          text-transform: uppercase;
          line-height: 1;
          word-break: break-word;
          color: #000000 !important;
        }
        
        .company-info {
          font-size: 8px !important;
          font-weight: bold !important;
          margin: 1px 0;
          line-height: 1;
          word-break: break-word;
          color: #000000 !important;
        }
        
        .separator {
          text-align: center;
          margin: 3px 0;
          font-size: 8px;
          color: #000000 !important;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          display: block;
          font-weight: bold !important;
        }
        
        /* Table Styles */
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 4px 0;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .transaction-info {
          font-size: 9px !important;
          margin: 4px 0;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .transaction-info td {
          padding: 1px 0;
          vertical-align: top;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .patient-name {
          word-break: break-word;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .items-table {
          margin: 4px 0;
          width: 100%;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .table-header {
          font-weight: bold !important;
          font-size: 9px !important;
          color: #000000 !important;
        }
        
        .table-header th {
          padding: 2px 0;
          font-weight: bold !important;
          color: #000000 !important;
        }
        
        .item-row td {
          padding: 2px 0;
          font-size: 9px !important;
          vertical-align: top;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .item-name {
          word-break: break-word;
          line-height: 1;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .item-qty {
          white-space: nowrap;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .item-price {
          white-space: nowrap;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .total-section {
          font-weight: bold !important;
          font-size: 11px !important;
          margin: 6px 0;
          color: #000000 !important;
        }
        
        .total-section td {
          padding: 3px 0;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .total-amount {
          font-size: 11px !important;
          white-space: nowrap;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .receipt-footer {
          margin-top: 6px;
          text-align: center;
          font-size: 8px !important;
          width: 100%;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .cashier-info {
          margin: 3px 0;
          font-weight: bold !important;
          word-break: break-word;
          font-size: 8px !important;
          color: #000000 !important;
        }
        
        .thank-you {
          margin: 4px 0;
          font-weight: bold !important;
          font-size: 8px !important;
          color: #000000 !important;
        }
        
        .receipt-id {
          margin: 2px 0;
          font-size: 7px !important;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        /* Ensure monospace for all numbers */
        td, th, p, span, div, h1, h2, h3, h4, h5, h6 {
          font-family: 'Courier New', monospace !important;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        .item-price, .total-amount {
          font-variant-numeric: tabular-nums;
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        /* Make separators extra bold */
        .separator {
          font-weight: bold !important;
          letter-spacing: 0.2px;
        }
        
        /* Print-specific optimizations */
        @media print {
          body {
            padding: 0 !important;
            margin: 0 !important;
            width: 60mm !important;
            max-width: 60mm !important;
            color: #000000 !important;
            font-weight: bold !important;
          }
          
          .thermal-receipt {
            width: 60mm !important;
            max-width: 60mm !important;
            padding: 1mm 2mm !important;
            margin: 0 auto !important;
            color: #000000 !important;
            font-weight: bold !important;
          }
          
          /* Force everything to stay within bounds */
          * {
            overflow: visible !important;
            max-width: 60mm !important;
            color: #000000 !important;
            font-weight: bold !important;
          }
          
          table {
            page-break-inside: avoid;
            color: #000000 !important;
            font-weight: bold !important;
          }
          
          /* Force bold text even if overridden */
          * {
            color: #000000 !important;
            font-weight: bold !important;
          }
          
          .branding-logo {
            max-width: 35mm !important;
            max-height: 15mm !important;
          }
        }
        
        /* Important: Ensure all text is black and bold */
        h1, h2, h3, h4, h5, h6, p, span, div, td, th {
          color: #000000 !important;
          font-weight: bold !important;
        }
        
        /* Extra bold for important elements */
        .company-name, .total-section, .total-amount {
          font-weight: bold !important;
        }
      `);
      printWindow.document.write("</style></head><body>");
      printWindow.document.write(printContents.outerHTML);
      printWindow.document.write("</body></html>");
      printWindow.document.close();

      // Print after a short delay to ensure content loads
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        setTimeout(() => {
          printWindow.close();
        }, 100);
      }, 250);
    },
  },

  mounted() {
    this.get_company();
    this.get_payments();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.mmodal-content {
  background: white;
  border-radius: 4px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.modal-body {
  padding: 20px;
}

/* Thermal receipt styling for screen preview */
.thermal-receipt {
  width: 280px;
  margin: 0 auto;
  padding: 10px;
  background: white;
  border: 1px solid #ddd;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: "Courier New", Courier, monospace;
  font-size: 10px;
  color: #000000;
  font-weight: bold !important;
}

/* Professional Logo Container */
.logo-container {
  text-align: center;
  width: 100%;
  margin: 0 auto 8px auto;
  padding: 5px 0;
}

.branding-logo {
  display: block;
  margin: 0 auto;
  max-width: 140px;
  max-height: 60px;
  width: auto;
  height: auto;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.text-left {
  text-align: left;
  color: #000000;
  font-weight: bold;
}

.text-right {
  text-align: right;
  color: #000000;
  font-weight: bold;
}

.company-name {
  font-size: 11px;
  font-weight: bold;
  margin: 2px 0;
  text-transform: uppercase;
  line-height: 1;
  color: #000000;
}

.company-info {
  font-size: 8px;
  font-weight: bold;
  margin: 1px 0;
  line-height: 1;
  color: #000000;
}

.separator {
  text-align: center;
  margin: 3px 0;
  font-size: 8px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  display: block;
  font-weight: bold;
}

/* Table Styles for Screen Preview */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 4px 0;
  color: #000000;
  font-weight: bold;
}

.transaction-info {
  font-size: 9px;
  color: #000000;
  font-weight: bold;
}

.transaction-info td {
  padding: 1px 0;
  vertical-align: top;
  color: #000000;
  font-weight: bold;
}

.patient-name {
  word-break: break-word;
  max-width: 150px;
  color: #000000;
  font-weight: bold;
}

.items-table {
  margin: 4px 0;
  color: #000000;
  font-weight: bold;
}

.table-header {
  font-weight: bold;
  font-size: 9px;
  color: #000000;
}

.table-header th {
  padding: 2px 0;
  font-weight: bold;
  color: #000000;
}

.item-row td {
  padding: 2px 0;
  font-size: 9px;
  vertical-align: top;
  color: #000000;
  font-weight: bold;
}

.item-name {
  word-break: break-word;
  line-height: 1;
  max-width: 120px;
  color: #000000;
  font-weight: bold;
}

.item-qty {
  white-space: nowrap;
  color: #000000;
  font-weight: bold;
}

.item-price {
  white-space: nowrap;
  color: #000000;
  font-weight: bold;
}

.total-section {
  font-weight: bold;
  font-size: 11px;
  margin: 6px 0;
  color: #000000;
}

.total-section td {
  padding: 3px 0;
  color: #000000;
  font-weight: bold;
}

.total-amount {
  font-size: 11px;
  color: #000000;
  font-weight: bold;
}

.receipt-footer {
  margin-top: 6px;
  text-align: center;
  font-size: 8px;
  color: #000000;
  font-weight: bold;
}

.cashier-info {
  margin: 3px 0;
  font-weight: bold;
  font-size: 8px;
  color: #000000;
}

.thank-you {
  margin: 4px 0;
  font-weight: bold;
  font-size: 8px;
  color: #000000;
}

.receipt-id {
  margin: 2px 0;
  font-size: 7px;
  color: #000000;
  font-weight: bold;
}

.print-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.print-btn:hover {
  background: #0056b3;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .mmodal-content {
    max-width: 95vw;
  }

  .thermal-receipt {
    width: 100%;
    max-width: 280px;
  }
}

/* Print simulation for better preview */
@media print {
  .thermal-receipt {
    width: 60mm !important;
    padding: 1mm 2mm !important;
    border: none !important;
    box-shadow: none !important;
    margin: 0 auto !important;
    color: #000000 !important;
    font-weight: bold !important;
  }

  .branding-logo {
    max-width: 35mm !important;
    max-height: 15mm !important;
  }
}
</style>
